import { costBreakdownV2WidgetDataByWidgetIdSelector } from "./costBreakdownV2WidgetDataByWidgetIdSelector";
import { RootState } from "../../../../../store";
import { ResourceExplorerGridDataWithId } from "../../../../../resource-explorer/utils/types/resourceExplorerDataGrid";
import { formatCostBreakdownREDataGridData } from "../../../../utils/helpers/costBreakdown/formatCostBreakdownREDataGridData";

export const costBreakdownV2WidgetTotalDataWithIdsSelector = (
  state: RootState,
  widgetId: string,
): ResourceExplorerGridDataWithId[] | undefined => {
  const data = costBreakdownV2WidgetDataByWidgetIdSelector(
    state,
    widgetId,
  )?.total;

  return formatCostBreakdownREDataGridData(data ?? [], true) ?? [];
};
